import React from "react";
import { Box } from "@mui/material";
import { HorizontalBarChartRow } from "./HorizontalBarChartRow";
import { HorizontalBarChartItem } from "./types";

export const HorizontalBarChart = ({
  data,
  textColor = "monochrome",
  alignPercentage = "right",
}: {
  data: HorizontalBarChartItem[];
  textColor?: "monochrome" | "gainLoss";
  alignPercentage?: "left" | "right";
}) => {
  const allValues = data.map((d) => d.value);

  const maxPositiveValue = Math.max(0, ...allValues.filter((v) => v > 0));
  const minNegativeValue = Math.min(0, ...allValues.filter((v) => v < 0));

  const valueRange = maxPositiveValue - minNegativeValue;

  const overallShiftPercentage =
    valueRange === 0
      ? 0 // Or 50 if you want a centered line when range is 0 and no bars
      : (Math.abs(minNegativeValue) / valueRange) * 100;
  const spacing = data.length <= 10 ? 2.15 : 1.25;

  return (
    <Box width="100%" height="100%" position="relative">
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        gap={spacing}
        height="100%"
      >
        {data.map(
          (
            { title, value, valueFormatted, color: barColor, isFake },
            index
          ) => {
            const isPositive = value >= 0;

            const currentBarWidth =
              valueRange === 0 ? 0 : (Math.abs(value) / valueRange) * 100;

            let barLeftPosition: number;
            if (isPositive) {
              barLeftPosition = overallShiftPercentage;
            } else {
              barLeftPosition = overallShiftPercentage - currentBarWidth;
            }

            barLeftPosition = Math.max(0, barLeftPosition);
            const maxAllowedWidth = 100 - barLeftPosition;
            const displayBarWidth = Math.min(currentBarWidth, maxAllowedWidth);

            const isLastRow = index === data.length - 1;

            return (
              <HorizontalBarChartRow
                key={`datas-${title}-${index}`}
                title={title}
                value={value}
                valueFormatted={valueFormatted}
                isPositive={isPositive}
                barLeftPosition={barLeftPosition}
                displayBarWidth={displayBarWidth}
                color={barColor}
                isFake={isFake}
                textColor={textColor}
                alignPercentage={alignPercentage}
                isLastRow={isLastRow}
                spacing={spacing}
              />
            );
          }
        )}
      </Box>
    </Box>
  );
};
